<template>
  <div id="NetEnvTest">
    <el-row class="top-title">
      <el-col :span="24" class="top-title">
        <h2>网络环境配置检测</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="testItem" label="测试项"></el-table-column>
          <el-table-column label="测试结果">
            <template slot-scope="scope">
              <span v-if="scope.row.tips != '正在检测...'">
                <i
                  class="el-icon-circle-check success"
                  v-if="scope.row.flag"
                ></i>
                <i class="el-icon-circle-close failure" v-else></i>
              </span>
              <span v-html="scope.row.tips"></span>
            </template>
          </el-table-column>
          <el-table-column></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Vue from 'vue'
import { $Url, guid } from '../plugins/utils'

export default {
  name: 'VodEnvTest',
  data() {
    return {
      inTesting: '正在检测...',
      tableData: [
        {
          testItem: '本地IP',
          tips: '正在检测...'
        },
        {
          testItem: '本地IP',
          tips: '正在检测...'
        },
        {
          testItem: '本地IP',
          tips: '正在检测...'
        },
        {
          testItem: '80端口',
          tips: '正在检测...'
        },
        {
          testItem: '443端口',
          tips: '正在检测...'
        },
        {
          testItem: 'socket消息',
          tips: '<span>聊天室连接失败，将无法参与直播互动</span>'
        },
        {
          testItem: '网络检测:Assets CDN',
          url: 'https://g.alicdn.com/tb/tracker/3.0.4/index.js',
          tips: '正在检测...'
        },
        {
          testItem: '网络检测:淘宝首页',
          url: 'https://www.alibaba.com',
          tips: '正在检测...'
        },
        {
          testItem: '网络检测:新浪首页',
          url: 'https://sina.cn',
          tips: '正在检测...'
        }
      ]
    }
  },
  methods: {
    testIP(index) {
      let url = 'http://ip-api.com/json/?lang=zh-CN'
      setTimeout(() => {
        var data = this.tableData[index]
        this.$http
          .jsonp(url)
          .then(resp => {
            var ip = resp.data.query
            var area = resp.data.country + resp.data.regionName + resp.data.city

            data.tips = 'IP: ' + ip + ' 所在地: ' + area
            data.flag = true
            Vue.set(this.tableData, index, data)
          })
          .catch(() => {
            data.tips = '连接失败'
            data.flag = false
            Vue.set(this.tableData, index, data)
          })
      })
    },
    getAliData(index) {
      let url =
        'https://' +
        guid() +
        '.dns-detect.alicdn.com/api/detect/DescribeDNSLookup'

      setTimeout(() => {
        var data = this.tableData[index]
        this.$http
          .jsonp(url, {
            params: {
              word: 'a'
            },
            jsonp: 'cb'
          })
          .then(resp => {
            if (resp.data.retCode === 200) {
              data.tips =
                'IP: ' +
                resp.data.content.localIp +
                ' DNS: ' +
                resp.data.content.ldns
              data.flag = true
              Vue.set(this.tableData, index, data)
            }
          })
          .catch(() => {
            data.tips = '连接失败'
            data.flag = false
            Vue.set(this.tableData, index, data)
          })
      })
    },
    getIPApiCO(index) {
      setTimeout(() => {
        var data = this.tableData[index]
        this.$http
          .get('https://ipapi.co/json/')
          .then(resp => {
            data.tips = 'IP: ' + resp.data.ip
            data.flag = true

            Vue.set(this.tableData, index, data)
          })
          .catch(() => {
            data.tips = '连接失败'
            data.flag = false
            Vue.set(this.tableData, index, data)
          })
      })
    },
    testPort(port, index) {
      var img = new Image()
      var data = this.tableData[index]
      var port_url = {
        '80':
          'http://wwwimg.polyv.net/assets/dist/images/web3.0/c-footer/icon-gaoxin.svg',
        '443':
          'https://wwwimg.polyv.net/assets/dist/images/web3.0/c-footer/icon-gaoxin.svg'
      }
      var err_tips = {
        '80': '<span>未开启80端口，将无法正常观看直播</span>',
        '443': '<span>未开启443端口，将无法正常观看直播</span>'
      }
      img.onload = () => {
        data.tips = '可用'
        data.flag = true
        Vue.set(this.tableData, index, data)
      }
      img.onerror = () => {
        data.tips = err_tips[port]
        data.flag = 'false'
        Vue.set(this.tableData, index, data)
      }
      img.src = port_url[port]
    },
    testMsg(index) {
      if (typeof WebSocket != 'undefined') {
        this.tableData[index].tips = '支持'
        this.tableData[index].flag = true
      } else {
        this.tableData[index].tips = '不支持'
        this.tableData[index].resultFlag = false
      }
    },
    testWeb() {
      for (let index in this.tableData) {
        if (this.tableData[index].url) {
          $Url(this.tableData[index].url)
            .then(() => {
              var data = this.tableData[index]
              data.tips = '连接成功'
              data.flag = true
              Vue.set(this.tableData, index, data)
            })
            .catch(() => {
              var data = this.tableData[index]
              data.tips = '连接失败'
              data.flag = false
              Vue.set(this.tableData, index, data)
            })
        }
      }
    }
  },
  created() {
    for (var i = 0; i < 3; i++) {
      this.testWeb()
    }
    // IP
    this.getAliData(0)
    this.getIPApiCO(1)
    this.testIP(2)
    // 端口
    this.testPort('80', 3)
    this.testPort('443', 4)
    // 消息通信
    this.testMsg(5)
  }
}
</script>
<style>
h2 {
  color: white;
}
.success {
  color: #67c23a;
  font-size: 25px;
}
.failure {
  color: red;
  font-size: 25px;
}</style
>>
